export const MESSAGES = {
    'Reschedule appointments first': true,
    'You can’t remove session with active appointments': true,
}